module.exports = __webpack_public_path__ + "img/Sams_Club.23ae5281.png";